import {titleColor} from "../constants";
import {fade} from "@material-ui/core/styles";

const styles = theme => ({
    root: {
        width: "100%",
        overflowX: "hidden",
        paddingTop: "70px",
        backgroundColor: fade(titleColor, 0.1),
    },

    textBox: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "10px",
        marginBottom: "60px",
        alignItems: "center",
    },

    smallText: {
        width: "100%",
        display: "flex",
        height: "150px",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            height: "100%",
        },
    },

    bigText: {
        display: "flex",
        height: "290px",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            height: "100%",
        },
    },

    textElement: {
        width: "100%",
        display: "flex",
        height: "230px",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            height: "100%",
        },
    },

    leftElement: {
        justifyContent: "flex-start",
    },

    rightElement: {
        justifyContent: "flex-end",
    },
});

export default styles;